module.exports = __webpack_public_path__ + "img/Quimica.ef6f8167.png";